import React from "react";
import Header from "./components/header/Header";
import Sidebar from "./components/sidebar/Sidebar";
import { Outlet } from "react-router-dom";
import Breadcome from "../components/ui/breadcome/Breadcome";
import Footer from "./components/footer/Footer";
import {useInactivityDetector} from "../lib/authenticationLibrary.js"

const Layout = (props) => {
  useInactivityDetector(3 * 60 * 60 * 1000);
  return (
    <React.Fragment>
      <div className="main-page-layout">
        <div className="top-sec">
          <Sidebar componentRoutes={props.componentRoutes} />
          <div className={`middle-page-section`}>
            <Header />
            <div className="center-content-part">
              <div className="content-desc-section">
                <Breadcome componentRoutes={props.componentRoutes} />
                <div className="center-container">
                  <Outlet />
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </React.Fragment>
  );
};

export default Layout;
